// import wakelock from '@/utils/wakelock'

const actions = {
  // requestWakeLockAction: async ({ getters }) => {
  //   if (getters.canUsePreventLockPresentingScreen) {
  //     wakelock.requestWakeLock()
  //   }
  // },
  // releaseWakeLockAction: async ({ getters }) => {
  //   if (getters.canUsePreventLockPresentingScreen) {
  //     wakelock.releaseWakeLock()
  //   }
  // },
}

export default actions
